import { createContext, useContext, useState } from "react";

const LangContext = createContext(null);

const read = () => {
  try { return localStorage.getItem("isEng") === "true"; } catch { return false; }
};

export function LangProvider({ children }) {
  const [isEng, setIsEng] = useState(read);
  const toggle = () => {
    setIsEng((v) => {
      try { localStorage.setItem("isEng", String(!v)); } catch {}
      document.documentElement.lang = v ? "th" : "en";
      return !v;
    });
  };
  // t("ไทย", "English") or t({ th, en }); plain strings pass through.
  const t = (a, b) => (typeof a === "object" && a ? (isEng ? a.en : a.th) : b === undefined ? a : isEng ? b : a);
  return <LangContext.Provider value={{ isEng, toggle, t }}>{children}</LangContext.Provider>;
}

export const useLang = () => useContext(LangContext);
